'use client'
import { useTranslations } from 'next-intl'
import HotelDetailsDesktopScreen from '@/src/containers/desktop/hotels/details/screen'
import PropertyGuestsField from '@/src/components/common/hotels/property/propertyGuestsField'
import usePropertyPageData from '@/src/hooks/hotels/usePropertyPageData'
import { SelectHotelData } from '@/src/types/hotels/details'
import { PropertyStay } from '@/src/utils/hotels/propertyStay'

interface PropertyDesktopContainerProps {
    locale: string
    hotelId: string
    hotelName: string
    domainCountry?: string
    /** Server-rendered content, so the hotel is in the HTML before any search runs. */
    initialData: SelectHotelData
    /** Stay the page pre-filled, since the URL carries no dates. */
    initialStay: PropertyStay
}

// SEO entry: arrives from a search engine with no dates and no prior search.
const PropertyDesktopContainer = ({
    locale,
    hotelId,
    hotelName,
    domainCountry,
    initialData,
    initialStay
}: PropertyDesktopContainerProps) => {
    const t = useTranslations('hotels')
    const { hasSearched, occupancy, ...data } = usePropertyPageData({ initialData, initialStay, hotelName, hotelId })

    return (
        <HotelDetailsDesktopScreen
            locale={locale}
            domainCountry={domainCountry}
            data={data}
            // No prices until the guest asks, so there is nothing for a rooms tab to show.
            availableTabs={hasSearched ? undefined : ['info', 'map']}
            defaultTab={hasSearched ? 'rooms' : 'info'}
            allowUnchangedDates={!hasSearched}
            // Everything open: this page is entered from a search engine, so its content
            // should be on screen and in the markup rather than behind a toggle.
            expandAll={!hasSearched}
            // Stays a labelled button after the search too — the icon reads as a date edit.
            searchLabel={t('searchRooms')}
            guestsField={<PropertyGuestsField variant="desktop" occupancy={occupancy} />}
        />
    )
}

export { PropertyDesktopContainer }
export default PropertyDesktopContainer
